// extracted by mini-css-extract-plugin
export default {"root_image_inner":"staffsForm_root_image_inner__vImPL"};